import axios from 'axios'
import apiList from './resource.js'
import newApi from "./newApi";

export default {
  // 直播列表
  getLiveList: function (data) {
    return axios.post(newApi.getAjaxUrl('openapi', 'getCourse'), data)
  },
  // 新的直播详情数据
  newgetLiveDetail: function (data) {
    return axios.get(apiList.live.liveDetail, { params: data })
  },
  // 直播列表2
  getCourseList: function (data, successfn, errorfn) {
    return axios.post(newApi.getAjaxUrl('openapi', 'getCourse'), data)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 用户课程列表
  getUserHistoryList: function (data, successfn, errorfn) {
    return axios.get(apiList.live.userHistoryList, { params: data })
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 获取动态轮播数据
  getDynamic: function (data, successfn, errorfn) {
    return axios.get(apiList.live.getDynamicList, { params: data })
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 获取课程顾问信息
  getCourseConsultant: function (successfn, errorfn) {
    return axios.get(apiList.live.courseConsultant)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 获取课程顾问信息--2
  getCourseConsultantNoThen: function () {
    return axios.get(apiList.live.courseConsultant)
  },
  // 获取云信用户信息
  getYunUserInfo: function (data, successfn, errorfn) {
    return axios.get(apiList.live.yunUserInfo, { params: data })
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 获取云信用户信息--2
  getYunUserInfoNoThen: function (data) {
    return axios.get(apiList.live.yunUserInfo, { params: data })
  },
  // 获取聊天室地址
  getChatroomAdress: function (data, successfn, errorfn) {
    return axios.post(apiList.live.chatroomAdress, data)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 获取直播状态查询
  getLiveStatus: function (data, successfn, errorfn) {
    return axios.get(apiList.live.liveStatus, {
      params: data
    })
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 获取云信用户信息--2
  getUserConsultant: function () {
    return axios.get(apiList.live.userConsultant)
  },
  // 获取用户投顾老师新
  getNewAdviser: function () {
    return axios.get(apiList.live.newAdviser)
  },
  // 获取分级课程列表
  getAdvancedCourseList: function (data, successfn, errorfn) {
    return axios.post(apiList.live.advancedCourse, data)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 审核用户消息录入
  examineHdMsg: function (data, successfn, errorfn) {
    return axios.post(apiList.live.examineHdMsg, data)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  }
}



// WEBPACK FOOTER //
// ./src/fetch/live.js